import ContinentContainer from './ContinentContainer';
export default ContinentContainer;



// WEBPACK FOOTER //
// ./src/containers/ContinentContainer/index.js